/**
 * @generated SignedSource<<f98d56c0462f3b0cabe9182c872e7b85>>
 * @relayHash 1c628fe52811d4f95438cda5d261a08c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 87a3e3ef7c426d7f580fe52dd5051dd664273e089477e7406a69dad97f854cef

import type { ConcreteRequest } from 'relay-runtime';
export type useStatusUpdatesAutomationNudgeActionQuery$variables = {
  contentId: string;
};
export type useStatusUpdatesAutomationNudgeActionQuery$data = {
  readonly singleContent: {
    readonly ancestors: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly history: {
      readonly ownedBy: {
        readonly accountId?: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly metadata: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly space: {
      readonly id: string | null;
    } | null;
    readonly title: string | null;
  } | null;
};
export type useStatusUpdatesAutomationNudgeActionQuery = {
  response: useStatusUpdatesAutomationNudgeActionQuery$data;
  variables: useStatusUpdatesAutomationNudgeActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ]
},
v5 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    }
  ]
},
v8 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    }
  ],
  "concreteType": "PaginatedContentList",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "concreteType": "ContentMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "createdDate"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "children(first:25)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1c628fe52811d4f95438cda5d261a08c",
    "id": "87a3e3ef7c426d7f580fe52dd5051dd664273e089477e7406a69dad97f854cef",
    "metadata": {},
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "operationKind": "query",
    "text": "query useStatusUpdatesAutomationNudgeActionQuery($contentId:ID!){singleContent(id:$contentId){id,title,space{id},ancestors{id,title},history{ownedBy{__typename,...on KnownUser{accountId}}},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "909b93e93164583bacce4408cc257c43";

export default node;
